import React, { useEffect } from "react";
import FirebaseAnalytics from "../services/analytics.service";
import Storage from "../services/storage.service";
import SimDeactivationPlansSuggestion from "../views/simDeactivation/sim-deactivation-plans-suggestion";
import SimDeactivationStepper from "../views/simDeactivation/stepper";

export default function SimDeactivationPlansSuggestionUI(props) {

	useEffect(() => {
      FirebaseAnalytics.generic_event(1);
      const stepsDetails = {
          step1: {
              // Number
              // Prepaid & Postpaid
            status: "isDone",
          },
          step2: {
              // OTP
              // Postpaid Only
            status: "isDone",
          },
          step3: {
              // Absher
              // PrePaid Only
            status: "isDone",
          },
          step4: {
              // Payment
              // Postpaid Only
            status: "inProgress",
          },
          step5: {
              // Confirmation
              // Prepaid & Postpaid
            status: "notVisited",
          }
      };
      Storage.set("act_step_detail", stepsDetails)
    }, [])

	return (
		<div className="storefront-two-col-pg">
			<SimDeactivationPlansSuggestion {...props}/>
			<SimDeactivationStepper />
		</div>
	)
}